module.exports = __webpack_public_path__ + "static/media/regulatory_small.fdae7250.jpg";